import { Modify } from "../utilities/modifyType";
import {deserializeWritingLog, SerializedWritingLog, WritingLog} from "./WritingLog";

export interface AssetWritingLogs {
    id: string;
    totalTime: number;
    writingLogs: WritingLog[]
}

export type SerializedAssetWritingLogs = Modify<
	AssetWritingLogs,
	{
		writingLogs: SerializedWritingLog[];
	}
>;

export const deserializeAssetWritingLogs = (model: SerializedAssetWritingLogs): AssetWritingLogs => {
	return {
		...model,
		writingLogs: model.writingLogs.map(deserializeWritingLog),
	};
};